/** 兑奖相关接口 */
import request from '@/utils/util.request';

/*
 *  (exchange) 获取页面数据
 *	@param {string} url：当前页面的完整url
 */
export const exchange_index = (data) => {
	return request({
		url: '/exchange/index',
		data,
	});
};

/*
 *  (exchange) 获取中奖数据
 *  @param {string} type：won | paid
 *  @param {int} offset：分页加载时的偏移数
 *  @param {int} limit：分页加载时的加载个数
 *
 */
export const exchange_load_data = (data) => {
	return request({
		url: '/exchange/loaddata',
		data,
	});
};

/*
 *  (exchange) 扫码后的兑奖接口
 *  @param {string} code: 扫码结果
 */
export const do_exchange = (data) => {
	return request({
		url: '/exchange/doexchange',
		data,
	});
};
